import { createBrowserRouter } from "react-router";
import { ProtectedRoutes, SuperAdminRoutes } from "@/components/ProtectedRoutes";

// Layouts:
import RootLayout from "@/layouts/RootLayout";
import MainLayout from "@/layouts/MainLayout";

// Pages:
import LoginPage from "@/pages/LoginPage";
import HomePage from "@/pages/HomePage";
import AssistantPage from "@/pages/AssistantPage";
import LegalAssistantPage from "@/pages/LegalAssistantPage";
import RecordingsPage from "@/pages/RecordingsPage";
import DocumentsPage from "@/pages/DocumentsPage";
import KnowledgePage from "@/pages/KnowledgePage";
import SearchPage from "@/pages/SearchPage";
import ConversationPage from "@/pages/ConversationPage";
import SuperAdminPage from "@/pages/SuperAdminPage";
import CourtScraperPage from "@/pages/CourtScraperPage";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import DeveloperPage from "@/pages/DeveloperPage";
import NotFoundPage from "@/pages/NotFoundPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import AccountPage from "@/pages/AccountPage";
import OfficeMembersPage from "@/pages/OfficeMembersPage";
import OfficeSettingsPage from "@/pages/OfficeSettingsPage";
import OfficeDashboardPage from "@/pages/OfficeDashboardPage";
import CasesPage from "@/pages/CasesPage";
import InvitationPage from "@/pages/InvitationPage";
import IntegrationsAuthorizePage from "@/pages/integrations/IntegrationsAuthorizePage";
import IntegrationsPage from "@/pages/integrations/IntegrationsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      // Public auth entry. Authenticated `/` is HomePage under MainLayout —
      // never bounce new/free users into an entitlement-gated app route.
      { path: "/login", element: <LoginPage /> },
      { path: "/unauthorized", element: <UnauthorizedPage /> },
      { path: "/terms-of-service", element: <TermsOfServicePage /> },
      { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
      { path: "/invitation", element: <InvitationPage /> },
      { path: "/integrations/authorize", element: <IntegrationsAuthorizePage /> },
      {
        element: <ProtectedRoutes />,
        children: [
          {
            path: "/",
            element: <MainLayout />,
            children: [
              { index: true, element: <HomePage /> },
              { path: "assistant", element: <AssistantPage /> },
              { path: "assistant/:conversationId", element: <ConversationPage /> },
              { path: "legal-assistant", element: <LegalAssistantPage /> },
              { path: "recordings", element: <RecordingsPage /> },
              { path: "documents", element: <DocumentsPage /> },
              { path: "knowledge", element: <KnowledgePage /> },
              { path: "search", element: <SearchPage /> },
              { path: "account", element: <AccountPage /> },
              { path: "cases", element: <CasesPage /> },
              { path: "integrations", element: <IntegrationsPage /> },
              { path: "office/dashboard", element: <OfficeDashboardPage /> },
              { path: "office/members", element: <OfficeMembersPage /> },
              { path: "office/settings", element: <OfficeSettingsPage /> },
              ...(import.meta.env.VITE_NODE_ENV === "development" ? [{ path: "developer", element: <DeveloperPage /> }] : []),
              {
                element: <SuperAdminRoutes />,
                children: [
                  { path: "/super-admin", element: <SuperAdminPage /> },
                  { path: "/court-scraper", element: <CourtScraperPage /> },
                  { path: "/super-admin/court-scraper", element: <CourtScraperPage /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);

export default router;
